import emZurag from "../images/featured/em1.png";
import em2Zurag from "../images/featured/em2.png";
import em3Zurag from "../images/featured/em3.png";
import em4Zurag from "../images/featured/em4.png";
import gbZurag from "../images/featured/gb1.png";
import gb2Zurag from "../images/featured/gb2.png";
import ahZurag from "../images/featured/ah1.png";
import ah2Zurag from "../images/featured/ah2.png";
import ah3Zurag from "../images/featured/ah3.png";
import tsevZurag from "../images/featured/tsev1.png";
import tsev2Zurag from "../images/featured/tsev2.png";
import tsev3Zurag from "../images/featured/tsev3.png";
import tsev4Zurag from "../images/featured/tsev4.png";
import zalZurag from "../images/featured/zaluils1.png";
import zal2Zurag from "../images/featured/zaluils2.png";
import zal3Zurag from "../images/featured/zaluils3.png";
import belZurag from "../images/featured/bel1.png";
import bel2Zurag from "../images/featured/bel2.png";
import bel3Zurag from "../images/featured/bel3.png";
import bel4Zurag from "../images/featured/bel4.png";
import bmodZurag from "../images/featured/bmod1.png";
import bmod2Zurag from "../images/featured/bmod2.png";
import bmod3Zurag from "../images/featured/bmod3.png";
import tballZurag from "../images/featured/tball1.png";
import tball2Zurag from "../images/featured/tball2.png";
import tball3Zurag from "../images/featured/tball3.png";
import tball4Zurag from "../images/featured/tball4.jpg";
import img9 from "../images/featured/9/1.png";
import img9_1 from "../images/featured/9/2.png";
// import img9_2 from "../images/featured/9/3.png";
import img10 from "../images/featured/10/1.png";
import img10_1 from "../images/featured/10/2.png";
import img10_2 from "../images/featured/10/3.png";
import img11 from "../images/featured/11/1.png";
import img11_1 from "../images/featured/11/2.png";
import img11_2 from "../images/featured/11/3.png";
import img12 from "../images/featured/12/1.jpg";
import img12_1 from "../images/featured/12/2.jpg";
import img12_2 from "../images/featured/12/3.jpg";
import img13 from "../images/featured/13/1.jpg";
import img13_1 from "../images/featured/13/2.jpg";
import img13_2 from "../images/featured/13/3.jpg";
import img14 from "../images/featured/14/1.jpg";
import img14_1 from "../images/featured/14/2.jpg";
import img15 from "../images/featured/15/1.jpg";
import img15_1 from "../images/featured/15/2.jpg";
import img15_2 from "../images/featured/15/3.jpg";
import img15_3 from "../images/featured/15/4.jpg";
import img16 from "../images/featured/16/1.jpg";
import img16_1 from "../images/featured/16/2.jpg";
import img16_2 from "../images/featured/16/3.jpg";
import img16_3 from "../images/featured/16/4.jpg";

import suImg1 from "../images/update/featuredThumb4.jpg";
import suImg2 from "../images/update/featuredThumb5.jpg";
import suImg3 from "../images/update/featuredThumb6.jpg";
import suImg4 from "../images/update/featuredThumb4.jpg";

// niigem
// bolov
// medic
// buh

const sainDurAjiluud = [
  {
    Id: "1",
    sImg: emZurag,
    img2: em2Zurag,
    img3: em3Zurag,
    img4: em4Zurag,
    suImg: suImg1,
    title: "Эрүүл мэндийн тусламж",
    slug: "eruul-mend",
    slugMn: "эрүүл-мэнд",
    thumb: "#Хайр",
    description:
      "Монгол Сувд Сүм нь хүмүүнлэг зорилгын хүрээнд олон нийтийн эрүүл мэндэд чиглэсэн тусламж, урьдчилан сэргийлэх үзлэг, зөвлөгөө, эрүүл мэндийн үйлчилгээ үзүүлэх ажлыг зохион байгууллаа. ",
    description2:
      "Энэ ажил нь зөвхөн өвчнийг илрүүлэх биш, иргэдийг өөрийнхөө биш, иргэдийг өөрийнхөө төлөө хариуцлага хүлээх ухамсар, өөрийгөө хайрлах хандлагад уриалсан үнэ цэнтэй үйл явдал байв.",
    description3:
      "Эрүүл нэгэн - гэрэлт ирээдүйг бүтээгч. Тиймээс бид хүн бүрд хүрч, халамж анхаарал, урьдчилан сэргийлэлт бүхий үйлчилгээ үзүүлэхийг зорьж байна.",
    category: "medic",
  },
  {
    Id: "2",
    sImg: gbZurag,
    suImg: suImg2,
    img2: gb2Zurag,
    title: "Гэр бүлийн өдөрлөг",
    slug: "ger-buliin-udurlug",
    slugMn: "гэр-бүл-өдөрлөг",
    thumb: "#Итгэл",
    description:
      "Монгол Сувд Сүм нь гэр бүлийн үнэ цэнийг дэмжих зорилгоор Гэр бүлийн өдөрлөг зохион байгууллаа. Энэхүү өдөрлөг нь гэр бүлийн гишүүдийн хамтын дурсамж, уялдаа холбоог бэхжүүлэх урам зоригтой, эерэг уур амьсгалыг бүрдүүлсэн билээ.",
    category: "niigem",
  },
  {
    Id: "3",
    sImg: ahZurag,
    suImg: suImg3,
    img2: ah2Zurag,
    img3: ah3Zurag,
    title: "Хүндлэлээр дүүрэн өдөр",
    slug: "ahmad",
    slugMn: "ахмадууд",
    thumb: "#Баяр хөөр",
    description:
      "Бидний зүгээс Батсүмбэрийн ахмадын асрамжийн газарт жил бүр зочлон, ахмад буурлуудтай нэг өдрийг хамтдаа өнгөрүүлж, халуун дулаан уур амьсгал дор өнгөрүүлдэг билээ. Амьдралынхаа арвин туршлагыг тээсэн эрхэм хүмүүсийнхээ дэргэд байж, тэдний дурсамжийг сонсон, сэтгэлээ хуваалцсан тэр өдөр бидний сэтгэлд онцгой дурсамж болон үлдлээ.",
    category: "niigem",
  },
  {
    Id: "4",
    sImg: tsevZurag,
    suImg: suImg4,
    img2: tsev2Zurag,
    img3: tsev3Zurag,
    img4: tsev4Zurag,
    title: "Нийгэмд эерэг хандлага түгээв",
    slug: "tseverlegee",
    slugMn: "цэвэрлэгээ",
    thumb: "#Үйлчлэл",
    description:
      "Нийгэмд эерэг хандлагыг түгээх зорилгын хүрээнд наадмын талбай, нийтийн эзэмшлийн гудамж, гадна орчны цэвэрлэгээ болон цас мөсний цэвэрлэгээний ажилд идэвхтэй оролцсон. ",
    description2:
      "Энэхүү санаачилга нь нийгмийн сайн сайхны төлөө хүн бүр оролцож болохыг харуулсан бодит жишээ юм. Энгийн үйлдлээр эхэлсэн энэ ажил олон хүнийг уриалан дуудаж, эерэг хандлагыг түгээх нэгэн гүүр болж чадлаа.",
    category: "niigem",
  },
  {
    Id: "5",
    sImg: zalZurag,
    img2: zal2Zurag,
    img3: zal3Zurag,
    title: "Залуучуудын сайн үйлс",
    slug: "zaluuchuud-sain-uils",
    slugMn: "залуучууд-сайн-үйлс",
    thumb: "#Гэгээ",
    description:
      "Манай нэгдсэн залуучуудын бүлэг энэ удаад гэр хорооллын иргэдэд зориулан сайн үйлсийн аян өрнүүллээ. Энэхүү аяны хүрээнд бид хандивын зүйлсийг цуглуулж, тусламж хэрэгтэй айл өрхүүдэд хүргэж өгсөн бөгөөд тэдний өдөр тутмын хэрэгцээнд чиглэсэн бодит дэмжлэг үзүүлсэн юм. Аяны гол зорилго нь зөвхөн эд материалын тусламжаар зогсохгүй, итгэл найдвар, хайр халамжийг түгээх байлаа.",
    category: "niigem",
  },
  {
    Id: "6",
    sImg: belZurag,
    img2: bel2Zurag,
    img3: bel3Zurag,
    img4: bel4Zurag,
    title: "Хүүхдүүдэд бэлэг гардуулав",
    slug: "beleg",
    slugMn: "бэлэг-гардуулах",
    thumb: "#Үйлчлэл",
    description:
      "Төр, иргэний нийгмийн байгууллагын уялдаа холбоог бэхжүүлэх зорилгоор дүүрэг, хороодын удирдлагуудтай үр бүтээлтэй уулзалтуудыг зохион байгуулж, хамтын ажиллагааг эхлүүллээ. Уулзалтын үеэр орон нутгийн хөгжлийн бодлого, иргэдийн оролцоог нэмэгдүүлэх боломж, нийгмийн сайн сайхны төлөө хэрэгжүүлж буй санаачилгуудын талаар харилцан санал солилцож, хамтран ажиллах тодорхой чиглэлүүдийг тогтоов.",
    category: "niigem",
  },
  {
    Id: "7",
    sImg: bmodZurag,
    img2: bmod2Zurag,
    img3: bmod3Zurag,
    title: "Мод тарив",
    slug: "mod-tarih",
    slugMn: "мод-тарих",
    thumb: "#Үйлчлэл",
    description:
      "Монгол Сувд Сүм нь нийтийн сайн сайхны төлөөх үйл ажиллагааныхаа хүрээнд Ботаникийн цэцэрлэгт мод тарих бэлтгэл ажилд оролцож, модны нүх ухах ажлыг гүйцэтгэлээ.",
    category: "niigem",
  },
  {
    Id: "8",
    sImg: tballZurag,
    img2: tball2Zurag,
    img3: tball3Zurag,
    img4: tball4Zurag,
    title: "T-ball спортыг дэмжив",
    slug: "t-ball",
    slugMn: "t-ball",
    thumb: "#Баяр хөөр",
    description:
      "БГД ийн 10, 13, 22 хорооны хүүхдийн баярын өдөрлөгт баяр хөөр нэмж Магтан,  Соёлын албаны залуучууд маань өөр өөрсдийн үүргээ гүйцэтгэж, үзүүлбэрүүдээ  үзүүлж Тийболлын тамирчиддаа иж бүрэн өмсгөл, хувцас хэрэглэл мөн баярын бэлэг гардууллаа. ",
    category: "bolov",
  },
  {
    Id: "9",
    sImg: img9,
    img2: img9_1,

    title:
      "2025/2026 оны Хичээлийн шинэ жилийг тохиолдуулан иж бүрэн хэрэглэл гардууллаа",
    slug: "9",
    slugMn: "Хичээлийн иж бүрэн хэрэглэл",
    thumb: "#Үйлчлэл",
    description:
      "БГД-ийн 13-р хорооны зорилтот бүлгийн 5 хүүхдэд хичээлийн шинэ жилийг тохиолдуулан иж бүрэн хэрэглэл гардууллаа.",
    category: "bolov",
    date: "2025-08-29",
  },
  {
    Id: "10",
    sImg: img10,
    img2: img10_1,
    img3: img10_2,
    title:
      "ЭХЭМҮТ-д эмчлүүлж буй хүүхдүүдэд хичээлийн иж бүрэн хэрэгсэл бэлэглэлээ",
    slug: "10",
    slugMn: "Хичээлийн иж бүрэн хэрэглэл-2",
    thumb: "#Үйлчлэл",
    description:
      "ЭХ ХҮҮХДИЙН ЭРҮҮЛ МЭНДИЙН ҮНДЭСНИЙ ТӨВ-д хэвтэн эмчлүүлж буй бяцхан хүүхдүүдэд хичээлийн шинэ жилийг тохиолдуулан иж бүрэн хичээлийн хэрэгсэл бэлэг болгог өглөө.",
    category: "bolov",
    date: "2025-08-29",
  },
  {
    Id: "11",
    sImg: img11,
    img2: img11_1,
    img3: img11_2,
    title: "“Эрүүл шүд эрүүл ирээдүй” сайн үйлсийн аяныг зохион байгууллаа",
    slug: "11",
    slugMn: "Эрүүл шүд эрүүл ирээдүй",
    thumb: "#Үйлчлэл",
    description:
      "БГД-ийн 76, 77 цэцэрлэгийн 3-6 насны хүүхдүүдийг хамарсан “Эрүүл шүд эрүүл ирээдүй” сайн үйлсийн аяанд амжилттай зохион байгууллаа",
    category: "medic",
    date: "2025-09-24",
  },
  {
    Id: "12",
    sImg: img12,
    img2: img12_1,
    img3: img12_2,
    title: "“Сар шинийг угтсан “Бүх нийтийн их цэвэрлэгээ”-г зохион байгууллаа",
    slug: "12",
    slugMn: "Бүх нийтийн их цэвэрлэгээ",
    thumb: "#Үйлчлэл",
    description:
      "Нийслэлийн хэмжээнд Сар шинийг угтсан “Бүх нийтийн их цэвэрлэгээ”-г зохион байгуулж байгаатай холбогдуулан хороодоос зааж өгсөн газрууд болон СХД 29 хорооны нутаг дэвсгэр Хаан хүнс , И март, Драгон орчим, Чингэлтэй дүүргийн 18 хорооны нутаг дэвсгэр дэх 6 буудлаас 7 буудал хүртэлх замын хоёр талын нийтийн эзэмшлийн гудамж, талбайг цэвэрлэлээ.",
    category: "niigem",
    date: "2026-02-12",
  },
  {
    Id: "13",
    sImg: img13,
    img2: img13_1,
    img3: img13_2,
    title: "Хайрын гар аян зохион байгууллаа",
    slug: "13",
    slugMn: "Хайрын гар",
    thumb: "#Үйлчлэл",
    description:
      "СХД-ийн ИТХ, СХД-ийн ХГБХХХ-ээс  хамтран зохион байгуулж байгаа Хайрын гар аянд Монгол сувд сүм нэгдлээ.",
    description2:
      "Хүүхдийг бие махбодын хүчирхийллээс хамгаалах, урьдчилан сэргийлэх Хайрын гар аяны хүрээнд Хайр түгээе 3 өдрийн өдөрлөг сургалт зохион байгуулж 50 гаруй хүүхэд урьж оролцуулан хөгжилтэй үзүүлбэр үзүүлэн, бяцхан цайллага хийж гарын бэлэг өглөө. Хайр бялхсан 3 өдөр баяр хөөр дүүрэн байлаа.",
    link: "https://www.facebook.com/shdfcy/videos/-%D0%BC%D0%BE%D0%BD%D0%B3%D0%BE%D0%BB-%D1%81%D1%83%D0%B2%D0%B4-%D1%81%D2%AF%D0%BC-%D1%85%D0%B0%D0%B9%D1%80%D1%8B%D0%BD-%D0%B3%D0%B0%D1%80-%D0%B0%D1%8F%D0%BD%D0%B4-%D0%BD%D1%8D%D0%B3%D0%B4%D1%8D%D0%BD-1000-%D1%85%D2%AF%D0%BD-%D0%BE%D1%80%D0%BE%D0%BB%D1%86%D0%BB%D0%BE%D0%BE-%D1%85%D2%AF%D2%AF%D1%85%D0%B4%D0%B8%D0%B9%D0%B3-%D0%B1%D0%B8%D0%B5-%D0%BC%D0%B0%D1%85%D0%B1%D0%BE%D0%B4%D1%8B%D0%BD-/2037548983864962/?rdid=PHcZ5vauV8J4iEOg",
    category: "niigem",
    date: "2026-04-27",
  },
  {
    Id: "14",
    sImg: img14,
    img2: img14_1,
    title: "БЗД 42-р хорооны бүжгийн өдөрлөг",
    slug: "14",
    slugMn: "Бүжгийн өдөрлөг",
    thumb: "#Үйлчлэл",
    description:
      "Баянзүрх дүүргийн 42 дугаар хорооны зүгээс сар бүрийн сүүлийн долоо хоногт зохион байгуулдаг нийтийн бүжгийн арга хэмжээг заал талбайгаар ханган хамтран ажилладаг билээ.",
    description2:
      "Мөн хорооны нутаг дэвсгэрийн тодорхой цэгүүдэд цэвэрлэгээ хийн хамтран ажиллаж байна.",
    link: "https://www.facebook.com/share/v/1D5nqh4yCD/",
    category: "niigem",
    date: "2026-04-30",
  },
  {
    Id: "15",
    sImg: img15_1,
    img2: img15,
    img3: img15_2,
    img4: img15_3,
    title: "2026 Эх үрсийн баярын үйл ажиллагаа",
    slug: "15",
    slugMn: "Хүүхдийн баяр 2026",
    thumb: "#Үйлчлэл",
    description:
      "МОНГОЛ СУВД СҮМ -ийн нийт итгэгч хамт олон нийгмийн хариуцлагын хүрээнд жил бүрийн Олон Улсын Эх Үрсийн Баярыг тохиолдуулан харьяа дүүрэг, хороо, албан байгууллагуудтай хуулийн хүрээнд холбогдон ажиллаж хүүхдийн баярын бэлэг гардуулан урлагийн тоглолтууд толилуулж хүүхдүүдээ баярлуулдаг уламжлалтай болсон билээ.",
    description2:
      "Энэ удаа ч мөн Эх үрсийн баяр үеэр Баянгол дүүргийн 8, 13, 24, 31, Баянзүрх дүүргийн 22, 40, 42, Сонгино-Хайрхан дүүргийн 29, Хан-Уул дүүргийн 7, 20, Чингэлтэй дүүргийн 18, Сүхбаатар дүүргийн 9-р хорооны харьяа нутаг дэвсгэрийн олон хөөрхөн бяцхан үрс, мөн сүмийн итгэгчдийнхээ хүүхдүүдэд бэлэг гардуулан баярлууллаа. Үрс бүхэн хайрлагдаж хамгаалагддаг, нүд дүүрэн мишээлтэй сэтгэл дүүрэн итгэлтэй амьдардаг байх болтугай. ",
    link: "https://www.facebook.com/share/p/1XckgpLERp/",
    category: "niigem",
    date: "2026-06-01",
  },
  {
    Id: "16",
    sImg: img16,
    img2: img16_1,
    img3: img16_2,
    img4: img16_3,
    title: "Эх дэлхийгээ хайрлая",
    slug: "16",
    slugMn: "Эх дэлхийгээ хайрлая сайн үйлсийн аян",
    thumb: "#Үйлчлэл",
    description:
      "МОНГОЛ СУВД СҮМ 2026 оны 6 сарын 12-ний өдөр ЭХ ДЭЛХИЙГЭЭ ХАЙРЛАЯ сайн үйлсийн аян амжилттай зохион байгууллаа",
    description2:
      "Уг аяны хүрээнд Баянзүрх дүүргийн 1, 2, 27-р хороо, Сүхбаатар дүүргийн 7, 11, 12, 13-р хорооны харьяа нутаг дэвсгэр буюу 17-н гүүрнээс 100 айл Golden Vill хотхоны гүүр хүртэл Сэлбэ голын дагуух нийт 2.6 км газрын хогийн цэвэрлэж үйлсээ харуулсан өдөр байлаа. Сайн үйлсийн аянд нийт Монгол Сувд Сүмийн 1800 гаруй итгэгчид оролцлоо.",
    link: "https://www.facebook.com/share/p/1TEgb7VuZq/",
    category: "niigem",
    date: "2026-06-12",
  },
];

export default sainDurAjiluud;
